import { BaseService } from './BaseService';
import { 
  Disponibilidad, 
  CreateMultipleDisponibilidadDto,
  DisponibilidadesPorDia,
  ApiResponse 
} from '../types';

/**
 * Servicio para gestionar disponibilidades de entrenadores
 */
class DisponibilidadService extends BaseService {
  constructor() {
    super('/disponibilidades');
  }

  /**
   * Crea múltiples disponibilidades para un día específico
   */
  async crearDisponibilidadesMultiples(data: CreateMultipleDisponibilidadDto): Promise<Disponibilidad[]> {
    const response = await fetch(`${this.baseURL}${this.endpoint}/multiples`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(data)
    });
    
    const apiResponse = await this.handleResponse<ApiResponse<Disponibilidad[]>>(response);
    return apiResponse.data || [];
  }

  /**
   * Obtiene las disponibilidades de la semana actual para un entrenador
   */
  async obtenerDisponibilidadesSemanaActual(entrenadorId: number): Promise<DisponibilidadesPorDia> {
    const response = await fetch(`${this.baseURL}${this.endpoint}/entrenador/${entrenadorId}/semana-actual`, {
      method: 'GET',
      headers: this.getHeaders()
    });
    
    const apiResponse = await this.handleResponse<ApiResponse<Disponibilidad[]>>(response);
    const disponibilidades = apiResponse.data || [];
    
    // Agrupar por día
    const sabado = disponibilidades.filter(d => {
      const fecha = new Date(d.fecha);
      return fecha.getDay() === 6; // Sábado
    });
    
    const domingo = disponibilidades.filter(d => {
      const fecha = new Date(d.fecha);
      return fecha.getDay() === 0; // Domingo
    });
    
    return { sabado, domingo };
  }
}

export const disponibilidadService = new DisponibilidadService();